import { useContext } from 'react';

import { useFeatureFlagStatus } from '@/flags/use-feature-flag';

import { EnnismoreAPIClientConfigContext, useApiSection } from '../contexts';

function useEnnismoreApiClientConfigContext() {
  const config = useContext(EnnismoreAPIClientConfigContext);

  if (!config) {
    throw new Error(
      `This hook must be used by a child of <EnnismoreApiClientProvider />`
    );
  }

  return config;
}

export function useEnnismoreApiClientConfig() {
  const config = useEnnismoreApiClientConfigContext();
  const section = useApiSection();

  // TODO: remove these when we fully switch to API Gateway
  const defaultGatewayEnabled = useFeatureFlagStatus('feature-api-gateway');
  const mmbGatewayEnabled = useFeatureFlagStatus('feature-api-gateway-mmb');
  const awsGatewayEnabled =
    section === 'mmb' ? mmbGatewayEnabled : defaultGatewayEnabled;

  if (awsGatewayEnabled) {
    return config.awsApiGateway;
  }

  return config.kong;
}

export function useKongEnnismoreApiClientConfig() {
  return useEnnismoreApiClientConfigContext().kong;
}

/**
 * Returns the API client config for MMB (Manage My Booking) section.
 * Uses the `feature-api-gateway-mmb` flag to determine which gateway to use.
 * When the flag is on, uses AWS API Gateway; otherwise uses Kong.
 */
export function useMmbEnnismoreApiClientConfig() {
  const config = useEnnismoreApiClientConfigContext();
  const awsGatewayEnabled = useFeatureFlagStatus('feature-api-gateway-mmb');

  if (awsGatewayEnabled) {
    return config.awsApiGateway;
  }

  return config.kong;
}
